import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import {MAIN_APP} from "../../MidiPlay.jsx";
import Colors from '../../resource/ResourceColors.jsx';
import TrackZoom, {DEFAULT_ZOOM_LOG} from '../tracks/TrackZoom.jsx';

import TrackMidiClockEvents, {MIDI_CLOCK_HEIGHT_REM} from '../tracks/TrackMidiClockEvents.jsx';
import TrackTimeSignatureEvents, {TIME_SIGNATURE_HEIGHT_REM} from '../tracks/TrackTimeSignatureEvents.jsx';
import TrackNoteEvents from '../tracks/TrackNoteEvents.jsx';
import TrackPedalEvents, {PEDAL_HEIGHT_REM} from '../tracks/TrackPedalEvents.jsx';

import SidebarMidiClockEvents from '../tracks/sidebars/SidebarMidiClockEvents.jsx';
import SidebarTimeSignatureEvents from '../tracks/sidebars/SidebarTimeSignatureEvents.jsx';
import SidebarNoteEvents from '../tracks/sidebars/SidebarNoteEvents.jsx';
import SidebarPedalEvents from '../tracks/sidebars/SidebarPedalEvents.jsx';

const FILES_TOP_REM = 15.5;
const TRACK_BORDER_REM = 0.25;

const TracksField = styled.div`
    position: absolute;
    overflow: auto;
    width: 85%;
    top: 0; 
    bottom: 0; 
`;

const TrackWrapper = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    background: ${Colors.right_diagonal_gradient_grey(30, 20)};
    border-bottom: ${TRACK_BORDER_REM}rem solid ${Colors.grey(20)};
`;

const SidebarWrapper = styled.div`
    position: relative;
    right: 0;
    top: 0;
    width: 100%;
    padding-left: 0.15rem;
    background: ${Colors.right_diagonal_gradient(50, 30)};
`;

const SidebarContainer = styled.div`
    position: fixed;
    right: 0;
    left: 85%;
    height: 100%;
    overflow:hidden;
    color: ${Colors.primary(90)};
`;

const GradientBorder = styled.div`
    position: fixed;
    top: ${FILES_TOP_REM}rem;
    left: 85%;
    height: 100%;
    width: 0.25rem;
    background: ${Colors.right_diagonal_gradient_grey(80, 20)};
`;

export class ViewerTracks extends Component {

    static propTypes = {
        events: PropTypes.object.isRequired
    }

    state = {
        zoom_factor: Math.exp(DEFAULT_ZOOM_LOG),
        events: this.props.events,
        all_refs: [],
        duration_ms: 0,
        tracks_field_ref: React.createRef(),
        midi_clock_events: [],
        time_signature_events: [],
        pedal_events: [],
        action_only_tracks: [],
        all_track_data: []
    };

    load_events(events) {
        const all_time_events = events.time_events;

        let current_midi_clock = 0;
        let midi_clock_events = [];
        all_time_events.forEach(time_event => {
            if (current_midi_clock !== time_event.midi_clock) {
                current_midi_clock = time_event.midi_clock;
                midi_clock_events.push({
                    midi_clock: time_event.midi_clock,
                    tick_index: time_event.tick_index,
                    timecode: time_event.timecode
                });
            }
        });

        const time_signature_events = all_time_events
            .filter(event => event.time_signature)
            .map(event => {
                return {
                    time_signature: event.time_signature,
                    tick_index: event.tick_index,
                    timecode: event.timecode
                }
            });

        const action_tracks = [];
        const track_count = events.track_count;
        for (let track = 0; track < track_count; track++) {
            action_tracks.push([]);
        }

        const pedal_events = [];
        let sustain_index = -1;
        all_time_events.forEach(event => {
            event.actions.filter(a => a.type === 9).forEach(a => {
                action_tracks[a.track].push(a);
            });
            if (event.sustain_index !== sustain_index) {
                pedal_events.push({
                    sustain_index: event.sustain_index,
                    track: event.sustain_index,
                    tick_index: event.tick_index,
                    timecode: event.timecode
                })
                sustain_index = event.sustain_index;
            }
        });

        let all_tracks = [];
        for (let track = 0; track < track_count; track++) {
            all_tracks.push([]);
        }
        all_time_events
            .filter(event => event.actions.length)
            .forEach(event => {
                const note_on_actions = event.actions.filter(a => a.type === 9);
                for (let track = 0; track < track_count; track++) {
                    const track_actions = note_on_actions
                        .filter(note_on_action => note_on_action.track === track)
                        .sort((a, b) => b.data[0] - a.data[0]);
                    if (track_actions.length) {
                        all_tracks[track].push({
                            timecode: event.timecode,
                            actions: track_actions
                        });
                    }
                }
            });
        const action_only_tracks = all_tracks
            .map((all_track, all_track_index) => {
                return {
                    track: all_track_index,
                    events: all_track
                }
            })
            .filter(obj => obj.events.length)

        const duration_ms = events.time_events[events.time_events.length - 1].timecode + 1000;

        console.log('midi_clock_events', midi_clock_events)
        console.log('time_signature_events', time_signature_events)
        console.log('pedal_events', pedal_events)
        console.log('action_only_tracks', action_only_tracks)

        const new_state = {
            events: events,
            duration_ms: duration_ms,
            midi_clock_events: midi_clock_events,
            time_signature_events: time_signature_events,
            pedal_events: pedal_events,
            action_only_tracks: action_only_tracks,
        }
        this.setState(new_state);
        return new_state;
    }

    componentDidMount() {
        const new_states = this.load_events(this.props.events);

        const tracks_bounds = this.state.tracks_field_ref.current.getBoundingClientRect();
        const halfway = tracks_bounds.width / 2;

        this.initialize_tracks(new_states);

        const that = this;
        setInterval(function () {
            if (!MAIN_APP.state.playing) {
                return;
            }
            const cursor_pos = MAIN_APP.state.cursor_pos / that.state.zoom_factor;
            if (that.state.tracks_field_ref.current) {
                const scroll_left = that.state.tracks_field_ref.current.scrollLeft;
                if (cursor_pos > scroll_left + 4 * halfway / 3) {
                    that.state.tracks_field_ref.current.scrollTo({
                        left: cursor_pos - halfway / 4,
                        behavior: 'smooth'
                    });
                }
            }
        }, 3000);
    }

    initialize_tracks(new_states) {

        const track_specs = [];

        const midi_clock_track_ref = React.createRef();
        const midi_clock_sidebar_ref = React.createRef();
        track_specs.push({
            height: MIDI_CLOCK_HEIGHT_REM,
            track_ref: midi_clock_track_ref,
            track: <TrackMidiClockEvents
                ref={midi_clock_track_ref}
                time_division={this.props.events.time_division}
                zoom_factor={this.state.zoom_factor}
                midi_clock_events={new_states.midi_clock_events}/>,
            sidebar_ref: midi_clock_sidebar_ref,
            sidebar: <SidebarMidiClockEvents
                ref={midi_clock_sidebar_ref}
                time_division={this.props.events.time_division}/>
        });

        const time_signature_track_ref = React.createRef();
        const time_signature_sidebar_ref = React.createRef();
        track_specs.push({
            height: TIME_SIGNATURE_HEIGHT_REM,
            track_ref: time_signature_track_ref,
            track: <TrackTimeSignatureEvents
                ref={time_signature_track_ref}
                zoom_factor={this.state.zoom_factor}
                time_signature_events={new_states.time_signature_events}/>,
            sidebar_ref: time_signature_sidebar_ref,
            sidebar: <SidebarTimeSignatureEvents ref={time_signature_sidebar_ref}/>
        });

        new_states.action_only_tracks.forEach(action_only_track => {
            const track_height = 20 / new_states.action_only_tracks.length;
            const notes_track_ref = React.createRef();
            const notes_sidebar_ref = React.createRef();
            track_specs.push({
                height: track_height,
                track_ref: notes_track_ref,
                track: <TrackNoteEvents
                    ref={notes_track_ref}
                    zoom_factor={this.state.zoom_factor}
                    note_events={action_only_track.events}
                    note_height_rem={track_height - 0.5}
                    track_index={action_only_track.track}/>,
                sidebar_ref: notes_sidebar_ref,
                sidebar: <SidebarNoteEvents
                    ref={notes_sidebar_ref}
                    track_index={action_only_track.track}/>
            });
        });

        const pedals_track_ref = React.createRef();
        const pedals_sidebar_ref = React.createRef();
        track_specs.push({
            height: PEDAL_HEIGHT_REM,
            track_ref: pedals_track_ref,
            track: <TrackPedalEvents
                ref={pedals_track_ref}
                zoom_factor={this.state.zoom_factor}
                pedal_events={new_states.pedal_events}/>,
            sidebar_ref: pedals_sidebar_ref,
            sidebar: <SidebarPedalEvents ref={pedals_sidebar_ref}/>
        });

        let top = 0;
        const all_track_data = track_specs.map((track_spec, track_index) => {
            const track_data = this.add_track(track_spec, top, new_states.duration_ms, track_index);
            top += track_spec.height;
            return track_data;
        });
        this.setState({
            all_track_data: all_track_data
        })
    }

    set_zoom_factor(zoom_factor) {
        console.log('zoom_factor', zoom_factor)
        this.state.all_track_data.forEach(track_data => {
            if (track_data.track_ref.current) {
                track_data.track_ref.current.set_zoom_factor(zoom_factor);
            }
            if (track_data.track_wrapper_ref.current) {
                track_data.track_wrapper_ref.current.style.width = this.state.duration_ms / zoom_factor + 'px';
            }
        });
        this.setState({zoom_factor: zoom_factor});
    }

    add_track(track_spec, top, duration_ms, track_index) {
        const track_style = {
            height: track_spec.height + 'rem',
            top: top + 'rem',
            width: duration_ms / this.state.zoom_factor + 'px'
        }
        const sidebar_style = {
            height: track_spec.height + 'rem',
            left: '0.25rem'
        }
        const track_wrapper_ref = React.createRef();
        const sidebar_wrapper_ref = React.createRef();
        const track_wrapper = <TrackWrapper
            ref={track_wrapper_ref}
            key={'track_' + track_index}
            style={track_style}>
            {track_spec.track}
        </TrackWrapper>;
        const sidebar_wrapper = <SidebarWrapper
            ref={sidebar_wrapper_ref}
            key={'sidebar_' + track_index}
            style={sidebar_style}>
            {track_spec.sidebar}
        </SidebarWrapper>

        return {
            track_ref: track_spec.track_ref,
            track_wrapper: track_wrapper,
            track_wrapper_ref: track_wrapper_ref,
            sidebar_ref: track_spec.sidebar_ref,
            sidebar_wrapper: sidebar_wrapper,
            sidebar_wrapper_ref: sidebar_wrapper_ref,
        };
    }

    tandem_scroll(target) {
        const topmost_bounding_rect = this.state.all_track_data[0].track_wrapper_ref.current.getBoundingClientRect();
        const all_tracks_bounds = this.state.tracks_field_ref.current.getBoundingClientRect();
        const scroll_diff = topmost_bounding_rect.top - all_tracks_bounds.top;
        this.state.all_track_data.forEach(track_data => {
            track_data.sidebar_wrapper_ref.current.style.top = scroll_diff + 'px'
        });
    }

    render() {
        const all_tracks = this.state.all_track_data.map(track_data => {
            return track_data.track_wrapper;
        });
        const all_sidebars = this.state.all_track_data.map(track_data => {
            return track_data.sidebar_wrapper;
        });
        return <TracksField
            key={'tracks-key'}
            ref={this.state.tracks_field_ref}
            onScroll={event => this.tandem_scroll(event.target)}>
            {all_tracks}
            <SidebarContainer>
                {all_sidebars}
                <GradientBorder/>
                <TrackZoom
                    duration_ms={this.state.duration_ms}
                    handle_zoom={zoom_factor => this.set_zoom_factor(zoom_factor)}/>
            </SidebarContainer>
        </TracksField>;
    }
}

export default ViewerTracks;
